let replace_element = (actionData) => {
    let $el = $(actionData.selector);
    $el.replaceWith(actionData.html);
};
export default replace_element;